<app-profile-accounts [type]="'joint'"></app-profile-accounts>